var React = require('react');

function Overview (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7.53,15.26A7.23,7.23,0,1,1,14.76,8,7.23,7.23,0,0,1,7.53,15.26Zm0-12.45A5.23,5.23,0,1,0,12.76,8,5.23,5.23,0,0,0,7.53,2.81Z","key":0}),React.createElement("rect",{"x":"13.44","y":"10.52","width":"2","height":"7.8","transform":"translate(-5.97 14.43) rotate(-44.99)","key":1})]);
}

Overview.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 18 18"};

module.exports = Overview;

Overview.default = Overview;
